import * as React from "react";
import { connect } from "react-redux";

import { TenantProfile } from "./TenantProfile";
import ApplicationLayout from "components/layout/ApplicationLayout";
import { TENANT_PROFILE_ROUTE } from "components/router/Routes";
import { StoreState } from "store";

const mapState = (state: StoreState) => ({
    tenantDetails: state.tenantDetailsReducer,
});
const connector = connect(mapState);

const TenantProfilePage = (): JSX.Element => {
    return <ApplicationLayout viewTitle={""} view={<TenantProfile />} mainRoute={TENANT_PROFILE_ROUTE} />;
};

export default connector(TenantProfilePage);
